import React, { useState, useRef } from 'react';
import style from './max.module.scss';
import {LmText} from "@mes-ui/lemma";
import { ymReachGoal } from '../../utils/metrics';

export default function CodeInput({ error, disabled, onComplete }) {
    const [code, setCode] = useState(['', '', '', '', '', '']);
    const inputRefs = useRef([]);

    const isYmSend = useRef(false);
    
    const handleChange = (e, index) => {
        const value = e.target.value;
        if (!/^\d*$/.test(value)) return;

        const digit = value.slice(-1);
        const newCode = [...code];
        newCode[index] = digit;
        setCode(newCode);

        // Отправляем цель при вводе первой цифры пин-кода и только один раз
        if (!isYmSend.current && newCode.join('').length === 1) {        
          ymReachGoal('spherumBindingInputPinCode');

          isYmSend.current = true;
        }

        // Автофокус на следующее
        if (digit && index < 5) {
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) nextInput.focus();
        }

        // Проверка на полный код
        const fullCode = newCode.join('');
        if (fullCode.length === 6) {
            onComplete(fullCode);
        } else {
            onComplete('');
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !code[index] && index > 0) {
            const prevInput = inputRefs.current[index - 1];
            if (prevInput) prevInput.focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault(); // критично!

        const pasted = e.clipboardData.getData('text').trim();
        const digits = pasted.replace(/\D/g, '');

        if (digits.length === 6) {
            // Устанавливаем все 6 цифр
            const newCode = digits.split('');
            setCode(newCode);
            onComplete(digits);

            // Фокус на последнее поле
            setTimeout(() => {
                const lastInput = inputRefs.current[5];
                if (lastInput) lastInput.focus();
            }, 0);
        }
        // Если не 6 — игнорируем (можно добавить ошибку, если нужно)
    };

    return (
        <div className={`${style.MaxCodeBox}`}>

            <div className={`${style.MaxCode}`}>
                {code.map((char, index) => (
                    <input
                        key={index}
                        ref={(el) => {
                            inputRefs.current[index] = el;
                        }}
                        type="text"
                        inputMode="numeric"
                        disabled={disabled}
                        maxLength="1"
                        value={char}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        onPaste={index === 0 ? handlePaste : undefined} // только первое поле ловит paste
                        onFocus={(e) => e.target.select()} // помогает при вставке
                        className={`${style.MaxInput} ${!!error.length && style.MaxInputError} ${disabled && style.MaxInputDisabled}`}
                        aria-label={`Цифра ${index + 1}`}
                    />
                ))}
            </div>

            {!!error.length && <LmText color={'error'} variant={'lg'} weight={'regular'}>{error}</LmText>}
        </div>
    );
}
